<div class="card-body p-0">
    <div class="tabcasino icasino">

        <!-- old i-casino -->
        <!-- <tabset *ngIf="data">
            <tab [heading]="'1 To ' + tabDt.name" *ngFor="let tabDt of data.tables;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                <tabset *ngIf="pTabId == i">
                    <tab *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                        <ng-template tabHeading>
                            {{innerTabDt.name}}
                        </ng-template>
                        <div class="row mx-0 home_casinos_thumb" *ngIf="tabId == j">
                            <div class="col-md-2 col-4 align-self-center text-center"  *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                <div class="casino position-relative" (click)="confirmBox(item, tabDt.name)">
                                    <img class="img-fluid" [src]="item.image_path">
                                    <a href="javascript:void(0);" class="btn casino-btn">Play Now</a>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </tab>
        </tabset> -->

        <!-- new icasino -->
        <tabset #parentTabs>
            <tab *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
                <ng-template tabHeading>
                    <!-- {{tabDt?.name | uppercase}} -->
                    {{tabDt?.name.charAt(0).toUpperCase() + tabDt?.name.slice(1)}}
                    <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
                </ng-template>
                <tabset #childTabs>
                    <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                        <ng-template tabHeading>
                            <img class="img-fluid tab-image" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                            <!-- {{innerTabDt?.name | uppercase}} -->
                            {{innerTabDt?.name.charAt(0).toUpperCase() + innerTabDt?.name.slice(1)}}
                        </ng-template>
                        <div class="row mx-0 home_casinos_thumb" *ngIf="tabId == j">
                            <div class="col-md-2 col-4 align-self-center text-center" (click)="confirmBox(item, tabDt.name)" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                                <div class="casino position-relative">
                                    <img class="img-fluid" [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" alt="{{item.name}}">
                                    <a href="javascript:void(0)" class="btn casino-btn">Play Now</a>
                                </div>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </tab>
        </tabset>


    </div>
</div>
<app-loader class="no-overlay" *ngIf="!data"></app-loader>

<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title pull-left">{{gameName}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="iframeUrl != ''">
            <iframe scrolling="no" [src]="iframeUrl" allowfullscreen="true" title="game" id="casino-link"></iframe>
        </div>
    </div>
</ng-template>
